import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'motion/react';
import { toSlug } from '../utils/routeUtils';
import '../styles/RouteQuickLinks.css';

const listVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.15 } },
};

const pillVariants = {
  hidden: { opacity: 0, y: 16, scale: 0.96 },
  show: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 360, damping: 26 } },
};

// International flight routes only — no Australian domestic routes.
const ROUTES = [
  { from: 'Sydney', to: 'New Delhi' },
  { from: 'Melbourne', to: 'New Delhi' },
  { from: 'Sydney', to: 'Mumbai' },
  { from: 'Melbourne', to: 'Mumbai' },
  { from: 'Sydney', to: 'Bengaluru' },
  { from: 'Melbourne', to: 'Hyderabad' },
  { from: 'Brisbane', to: 'Chennai' },
  { from: 'Perth', to: 'Ahmedabad' },
  { from: 'Sydney', to: 'Auckland' },
  { from: 'Melbourne', to: 'Auckland' },
  { from: 'Sydney', to: 'Queenstown' },
  { from: 'Brisbane', to: 'Christchurch' },
  { from: 'Melbourne', to: 'Denpasar' },
  { from: 'Sydney', to: 'Denpasar' },
];

function RouteQuickLinks() {
  const reduce = useReducedMotion();

  return (
    <section className="route-quick-links" aria-label="Popular international flight routes">
      <motion.div
        className="route-quick-links__heading"
        initial={reduce ? false : { opacity: 0, y: 20 }}
        whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      >
        <h2 className="route-quick-links__title">Top Flight Routes</h2>
        <p className="route-quick-links__subtitle">Popular international routes loved by our travellers</p>
      </motion.div>
      <motion.ul
        className="route-quick-links__list"
        variants={listVariants}
        initial={reduce ? false : 'hidden'}
        whileInView={reduce ? undefined : 'show'}
        viewport={{ once: true, amount: 0.15 }}
      >
        {ROUTES.map((route, idx) => (
          <motion.li key={`${route.from}-${route.to}-${idx}`} variants={pillVariants}>
            <Link
              to={`/flights/${toSlug(route.from)}/${toSlug(route.to)}`}
              className="route-quick-links__route"
            >
              {route.from} to {route.to}
            </Link>
          </motion.li>
        ))}
      </motion.ul>
    </section>
  );
}

export default RouteQuickLinks;
